import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function CountUpNumber({
  target,
  prefix,
  suffix,
  isInView
}: {
  target: number;
  prefix?: string;
  suffix?: string;
  isInView: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const duration = 1200;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isInView, target]);
  return <span className="font-serif-display font-bold text-5xl sm:text-6xl md:text-7xl" style={{
    color: '#D4A017'
  }} data-id="element-111">
      {prefix}
      {count}
      {suffix}
    </span>;
}
export function RevealSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full" style={{
    backgroundColor: '#122240'
  }} data-id="element-112">
      {/* Top stitch */}
      <div style={{
      borderTop: '3px dashed #D4A017',
      opacity: 0.3
    }} data-id="element-113" />

      <div className="max-w-4xl mx-auto px-6 py-12 md:py-18" ref={ref} data-id="element-114">
        {/* Section headline */}
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-115">
          <p className="font-body text-sm uppercase tracking-widest mb-4" style={{
          color: '#D4A017'
        }} data-id="element-116">
            El Secreto
          </p>
          <h2 className="font-serif-display font-bold text-3xl md:text-4xl lg:text-5xl" style={{
          color: '#FAF3E8'
        }} data-id="element-117">
            El Método de{' '}
            <span className="text-gold-gradient" data-id="element-118">Alteración Express</span>
          </h2>
        </motion.div>

        {/* Explanation copy */}
        <motion.div className="max-w-2xl mx-auto text-center mb-10" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-119">
          <p className="font-body text-lg md:text-xl leading-relaxed mb-4" style={{
          color: 'rgba(250, 243, 232, 0.8)'
        }} data-id="element-120">
            Mientras otras enseñan a hacer patrones de papel aburridos, yo te
            enseño el{' '}
            <strong style={{
            color: '#D4A017'
          }} data-id="element-121">
              Método de Alteración Express
            </strong>
            .
          </p>
          <p className="font-serif-display font-bold text-2xl md:text-3xl" style={{
          color: '#FAF3E8'
        }} data-id="element-122">
            No vamos a diseñar. Vamos a{' '}
            <span style={{
            color: '#D4A017'
          }} data-id="element-123">
              SOLUCIONAR.
            </span>
          </p>
        </motion.div>

        {/* Math breakdown */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-124">
          <motion.div className="text-center p-8 rounded-2xl" style={{
          backgroundColor: 'rgba(212, 160, 23, 0.08)',
          border: '1px solid rgba(212, 160, 23, 0.2)'
        }} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-125">
            <CountUpNumber target={20} prefix="$" suffix="" isInView={isInView} data-id="element-126" />
            <p className="font-body text-base mt-3" style={{
            color: 'rgba(250, 243, 232, 0.7)'
          }} data-id="element-127">
              Un ruedo de jean
            </p>
            <p className="font-body text-sm mt-1" style={{
            color: 'rgba(250, 243, 232, 0.45)'
          }} data-id="element-128">
              15 minutos
            </p>
          </motion.div>

          <motion.div className="text-center p-8 rounded-2xl" style={{
          backgroundColor: 'rgba(212, 160, 23, 0.08)',
          border: '1px solid rgba(212, 160, 23, 0.2)'
        }} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.35
        }} data-id="element-129">
            <CountUpNumber target={60} prefix="$" suffix="" isInView={isInView} data-id="element-130" />
            <p className="font-body text-base mt-3" style={{
            color: 'rgba(250, 243, 232, 0.7)'
          }} data-id="element-131">
              Tres en una hora
            </p>
            <p className="font-body text-sm mt-1" style={{
            color: 'rgba(250, 243, 232, 0.45)'
          }} data-id="element-132">
              Desde tu casa
            </p>
          </motion.div>

          <motion.div className="text-center p-8 rounded-2xl" style={{
          backgroundColor: 'rgba(212, 160, 23, 0.12)',
          border: '1px solid rgba(212, 160, 23, 0.3)'
        }} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-133">
            <span className="font-serif-display font-bold text-5xl sm:text-6xl md:text-7xl" style={{
            color: '#D4A017'
          }} data-id="element-134">
              &gt;$40
            </span>
            <p className="font-body text-base mt-3" style={{
            color: 'rgba(250, 243, 232, 0.7)'
          }} data-id="element-135">
              Por hora
            </p>
            <p className="font-body text-sm mt-1" style={{
            color: 'rgba(250, 243, 232, 0.45)'
          }} data-id="element-136">
              Más que limpieza o restaurante
            </p>
          </motion.div>
        </div>

        {/* Lifestyle line */}
        <motion.p className="text-center font-serif-display italic text-xl md:text-2xl mb-10" style={{
        color: 'rgba(250, 243, 232, 0.65)'
      }} initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-137">
          "Y lo haces desde tu casa, con tu café y tu música."
        </motion.p>

        {/* Course content image */}
        <motion.div className="flex justify-center" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.7,
        delay: 0.4
      }} data-id="element-138">
          <img src="https://cdn.magicpatterns.com/uploads/42g6R3hUrG45v3H479ohVN/elmetodoexpress2.png" alt="Vista previa del contenido del curso El Método Express Alteraciones — módulos de video, guías técnicas y cheat sheets" className="w-full max-w-2xl rounded-xl shadow-2xl" data-id="element-139" />
        </motion.div>
      </div>

      {/* Bottom stitch */}
      <div style={{
      borderTop: '3px dashed #D4A017',
      opacity: 0.3
    }} data-id="element-140" />
    </section>;
}